<h2 mat-dialog-title class="dialog-title">
  <span class="title-icon"><mat-icon>person_search</mat-icon></span>
  <span>{{ showForm ? 'Cadastrar paciente' : 'Selecione o paciente' }}</span>
</h2>

<mat-dialog-content class="mat-typography patient-dialog-content">
  <section *ngIf="!showForm" class="patient-picker">
    <p class="dialog-description">Encontre o cadastro para continuar com o agendamento.</p>

    <mat-form-field class="patient-search" appearance="outline">
      <mat-label>Buscar paciente</mat-label>
      <input
        type="search"
        matInput
        [(ngModel)]="search"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Nome, CPF, telefone ou e-mail"
        aria-label="Buscar paciente por nome, CPF, telefone ou e-mail"
      />
      <button
        *ngIf="search"
        mat-icon-button
        matSuffix
        type="button"
        aria-label="Limpar busca"
        (click)="search = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-icon matSuffix *ngIf="!search">search</mat-icon>
    </mat-form-field>

    <div class="patient-list-heading" *ngIf="!loadingPatients && !patientLoadError">
      <span>Pacientes disponíveis</span>
      <span class="patient-count">
        {{ filteredPatients().length }} {{ filteredPatients().length === 1 ? 'resultado' : 'resultados' }}
      </span>
    </div>

    <div *ngIf="loadingPatients" class="picker-state" role="status" aria-live="polite">
      <span class="loading-indicator" aria-hidden="true"></span>
      <span>Carregando pacientes...</span>
    </div>

    <div *ngIf="patientLoadError" class="picker-state picker-error" role="alert">
      <mat-icon>cloud_off</mat-icon>
      <p>{{ patientLoadError }}</p>
      <button mat-stroked-button color="primary" type="button" (click)="getPatient()">
        <mat-icon>refresh</mat-icon>
        Tentar novamente
      </button>
    </div>

    <div
      class="patient-list"
      *ngIf="!loadingPatients && !patientLoadError && filteredPatients().length"
      aria-label="Resultados de pacientes"
    >
      <mat-card
        class="patient-card"
        *ngFor="let patient of filteredPatients(); trackBy: trackByPatient"
      >
        <button
          class="patient-select"
          type="button"
          (click)="onClickSelectPatient(patient)"
          [attr.aria-label]="'Selecionar paciente ' + patient.name"
        >
          <span class="patient-avatar">
            <img [src]="getPatientPhoto(patient)" alt="" />
          </span>
          <span class="patient-info">
            <span class="patient-name">{{ patient.name }}</span>
            <span class="patient-phone">
              <mat-icon>call</mat-icon>
              {{ getPatientPhone(patient) }}
            </span>
          </span>
          <span class="select-label">Selecionar</span>
          <mat-icon class="select-arrow" aria-hidden="true">arrow_forward</mat-icon>
        </button>

        <button
          *ngIf="isSecretaryOwner(patient)"
          mat-icon-button
          color="primary"
          type="button"
          class="edit-patient-button"
          [attr.aria-label]="'Editar cadastro de ' + patient.name"
          (click)="editPatient(patient, $event)"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </mat-card>
    </div>

    <div
      *ngIf="!loadingPatients && !patientLoadError && !filteredPatients().length"
      class="picker-state empty-state"
      role="status"
    >
      <mat-icon>{{ patients.length ? 'search_off' : 'group_off' }}</mat-icon>
      <p class="empty-title">
        {{ patients.length ? 'Nenhum paciente encontrado' : 'Nenhum paciente cadastrado' }}
      </p>
      <p class="empty-description">
        {{ patients.length ? 'Confira o nome, CPF ou telefone e tente novamente.' : 'Cadastre o paciente para iniciar o agendamento.' }}
      </p>
      <button
        *ngIf="patients.length && search"
        mat-button
        color="primary"
        type="button"
        (click)="search = ''"
      >
        Limpar busca
      </button>
    </div>
  </section>

  <div class="patient-registration">
    <button
      *ngIf="showForm"
      mat-button
      color="primary"
      type="button"
      class="back-to-list"
      (click)="showForm = false"
    >
      <mat-icon>arrow_back</mat-icon>
      Voltar para pacientes
    </button>

  <!-- Template compartilhado -->
  <ng-template #patientFormFields let-form="form">
    <div [formGroup]="form">
      <!-- Nome completo -->
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Nome completo</mat-label>
        <input matInput formControlName="name" placeholder="Digite o nome completo" />
        <mat-error *ngIf="form.get('name')?.hasError('required')">
          Campo obrigatório.
        </mat-error>
        <mat-error *ngIf="form.get('name')?.hasError('pattern')">
          Informe um nome válido (somente letras e espaços).
        </mat-error>
      </mat-form-field>

      <!-- CPF -->
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>CPF</mat-label>
        <input
          matInput
          formControlName="cpf"
          placeholder="Digite o CPF"
          mask="000.000.000-00"
          required
        />
        <mat-error *ngIf="form.get('cpf')?.hasError('required')">
          Campo obrigatório
        </mat-error>
        <mat-error *ngIf="form.get('cpf')?.hasError('cpfInvalid')">
          Informe um CPF válido
        </mat-error>
      </mat-form-field>

      <!-- Telefone -->
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Telefone</mat-label>
        <input
          matInput
          formControlName="phone"
          placeholder="Digite o telefone"
          prefix="+55 "
          mask="(00) 00000-0000"
          [dropSpecialCharacters]="true"
        />
        <mat-error *ngIf="form.get('phone')?.hasError('required')">
          Campo obrigatório
        </mat-error>
        <mat-error *ngIf="form.get('phone')?.hasError('phoneInvalid')">
          Informe um número de celular válido.
        </mat-error>
      </mat-form-field>

      <!-- Data de nascimento -->
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Data de Nascimento</mat-label>
        <input
          matInput
          formControlName="birthDate"
          placeholder="Digite sua data de nascimento"
          mask="00/00/0000"
        />
        <mat-error *ngIf="form.get('birthDate')?.hasError('required')">
          Campo obrigatório.
        </mat-error>
        <mat-error *ngIf="form.get('birthDate')?.hasError('datevalidator')">
          Informe uma data de nascimento válida.
        </mat-error>
      </mat-form-field>

      <!-- Gênero -->
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Gênero</mat-label>
        <mat-select formControlName="gender">
          <mat-option value="female">Feminino</mat-option>
          <mat-option value="male">Masculino</mat-option>
          <mat-option value="unknown">Não informado</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-template>

  <!-- Formulário de novo paciente -->
  <form *ngIf="showForm" class="patient-form" [formGroup]="newPatientForm">
    <page-alert
      [message]="messageSuccess"
      *ngIf="showSuccessMessage"
      alertClass="alert-success"
    ></page-alert>

    <page-alert
      [message]="messageError"
      *ngIf="showErrorMessage"
      alertClass="alert-danger"
    ></page-alert>

    <ng-container
      *ngTemplateOutlet="patientFormFields; context: { form: newPatientForm }"
    ></ng-container>

    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="requestCreatePatient()"
      [disabled]="newPatientForm.invalid || showSuccessMessage"
    >
      Confirmar Dados
    </button>
  </form>
  </div>

  <!-- Modal editar paciente -->
  <ng-template #editPatientDialog>
    <h2 mat-dialog-title>Editar paciente</h2>

    <mat-dialog-content class="mat-typography">
      <form class="patient-form" [formGroup]="editPatientForm">
        <ng-container
          *ngTemplateOutlet="patientFormFields; context: { form: editPatientForm }"
        ></ng-container>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-stroked-button color="primary" type="button" (click)="closeEditModal()">
        Cancelar
      </button>
      <button 
        mat-flat-button
        color="primary"
        type="button"
        (click)="updatePatient()"
        [disabled]="editPatientForm.invalid"
      >
        Salvar
      </button>
    </mat-dialog-actions>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end" class="patient-dialog-actions">
  <button mat-stroked-button color="primary" type="button" [mat-dialog-close]="false">
    Fechar
  </button>
  <button mat-flat-button color="primary" type="button" (click)="onNotFound()" *ngIf="!showForm">
    <mat-icon>person_add</mat-icon>
    Cadastrar paciente
  </button>
</mat-dialog-actions>
